import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyAv_WfdFQlhFOKwXtpECs-DKehMdSNiz20'
       key: 'AIzaSyB1HYt83X_kalT4vinVi0G9ZibslCSdbhc'
  }
})
